


























































































































































import {Language, InternationalizedField} from '../api/common';
import {Component, Prop, Model} from 'vue-property-decorator';
import VideosI18n from '../api/videos-i18n';
import {BusEvent} from '@/models/bus';
import CommonVue from '../models/commonVue';
import Modal from '@/components/Modal.vue';
import EditIcon from '../components/icons/EditIcon.vue';

@Component({
    components: {
        'modal': Modal,
        'edit-icon': EditIcon,
    },
})
export default class FieldVideosI18n extends CommonVue {
    public languageOptions: object[] = null;
    public language: string = Language.DEFAULT;

    @Model() public videos_i18n!: InternationalizedField<VideosI18n[]>;
    @Prop({type: Boolean, default: false}) public disabled?: boolean;
    public video: VideosI18n = null;
    public showModal: boolean = false;

    public start_time: string = undefined;
    public end_time: string = undefined;
    public display_condition: string = undefined;

    public beforeMount() {
        this.loadLanguageOptions();
    }
    public mounted() {
        if (this.videos_i18n.get(this.language) === undefined) {
            this.videos_i18n.set(this.language, []);
        }

    }
    // noinspection JSMethodCanBeStatic
    public timeToString(time: number): string {
        if (time) {
            return `${Math.floor(time/60).toString().padStart(2, '0')}:${(time%60).toString().padStart(2, '0')}`;
        } else {
            return '';
        }
    }
    public loadLanguageOptions() {
        this.languageOptions = [];
        for (const option of Language.LIST) {
            this.languageOptions.push({ key: option, flag: Language.flagOf(option), value: option, text: Language.codeOf(option)});
        }
    }
    // noinspection JSMethodCanBeStatic
    public stringToTime(string: string): number {
        // time in seconds eg: 59
        let regex = /^[0-9]*$/;
        let time = regex.exec(string);
        if (time) {
            return parseInt(time[0], 10);

        // time with minutes eg: 1:59
        } else {
            regex = /^([0-9]+):([0-9]+)$/;
            time = regex.exec(string);
            if (time) {
                const minutes = parseInt(time[1], 10);
                const seconds = parseInt(time[2], 10);
                return minutes * 60 + seconds;
            }
        }
        throw Error('Insert time with the format mm:ss (eg: 1:20) or in seconds (eg: 80).');
    }

    public newVideo() {
        this.video = new VideosI18n();
        this.video.language = this.language;
        this.showModal = true;
        this.start_time = this.timeToString(this.video.start_time);
        this.end_time = this.timeToString(this.video.end_time);
        this.display_condition = this.video.display_condition;
    }

    public edit(video: VideosI18n) {
        this.video = video;
        this.showModal = true;
        this.start_time = this.timeToString(this.video.start_time);
        this.end_time = this.timeToString(this.video.end_time);
        this.display_condition = this.video.display_condition;
    }

    // noinspection JSMethodCanBeStatic
    public getLink(video: VideosI18n): string {
        const regex = /(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|[a-zA-Z0-9_\-]+\?v=)([^#&?\n<>'"]*)/;
        const linkCode = regex.exec(video.path);
        if (linkCode && video.start_time) {
            return `https://www.youtube.com/embed/${linkCode[2]}?rel=0&amp;start=${video.start_time}`;
        } else if (linkCode) {
            return `https://www.youtube.com/embed/${linkCode[2]}?rel=0&amp`;
        } else {
            return '';
        }
    }

    public saveClicked() {
        if (!this.video) {
            return;
        }

        this.busy = true;

        try {

            if (this.start_time) {
                this.video.start_time = this.stringToTime(this.start_time);
            }

            if (this.end_time) {
                this.video.end_time = this.stringToTime(this.end_time);
            }

            if (this.display_condition) {
                this.video.display_condition = this.display_condition;
            }

            this.checkMandatoryFields();
            if (this.video.state === 'created') {
                if (!this.videos_i18n.get(this.language)) {
                    this.videos_i18n.set(this.language, []);

                }
                this.videos_i18n.get(this.language).push(this.video);
            }
            this.video.state = 'updated';
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save video', e);
        }
    }
    
    public checkMandatoryFields() {
        // Check if link is filled
        if(!this.video.path) {
            throw Error('Please insert a link for your video.');
        }
    }
    
    public deleteClicked() {
        this.video.state = 'deleted';
        this.showModal = false;
    }
}
